import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { permVisible } from "../lib/permissions";
import { Warning } from "@phosphor-icons/react";

// A single amber chip in the top bar — no full-width banner.
export default function OverdueTasksChip() {
  const { user } = useAuth();
  const canSeeTasks = !!user && (user.role === "admin" || permVisible(user, "tasks") === true);

  const { data } = useQuery({
    queryKey: ["task-reminders"],
    queryFn: async () => (await api.get("/tasks/reminders")).data,
    refetchInterval: 60000,
    enabled: canSeeTasks,
    staleTime: 30000,
  });

  const overdue = (data?.items || []).filter((i) => i.urgency === "overdue").length;
  if (!canSeeTasks || !overdue) return null;

  return (
    <Link
      to="/tasks"
      data-testid="overdue-tasks-chip"
      title="Tasks past their due date"
      className="hidden sm:inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-500/12 border border-amber-500/30 text-amber-300 text-xs hover:bg-amber-500/20 transition-colors shrink-0"
    >
      <Warning size={13} weight="fill" />
      <span className="tnum font-medium">{overdue}</span>
      <span className="hidden 2xl:inline">overdue task{overdue === 1 ? "" : "s"}</span>
    </Link>
  );
}
